<div class="container-fluid form">
    <div class="row" *ngIf="CurrentState=='Wait'">
        <div class="col-md-12  close-form">
            <h2> {{'resetPassword.text1' | translate}}</h2>
        </div>
    </div>
    <div class="row"
        *ngIf="CurrentState=='NotVerified'">
        <div class="col-md-12">
            <h2> {{'resetPassword.text2' | translate}}</h2>
        </div>
    </div>
    <div class="row" *ngIf="CurrentState=='Verified'">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5">
                <div class="card-body">
                    <h5 class="card-title text-center">{{'resetPassword.text3' | translate}}</h5>
                    <div>
                        <div id="errorMsg" *ngIf="errorMessage">
                            <span>{{errorMessage}}</span>
                        </div>
                        <div id="successMsg" *ngIf="successMessage">
                            <span>{{successMessage}}</span>
                        </div>
                        <form action="" [formGroup]="passwordResetForm" (ngSubmit)="ResetPassword(passwordResetForm)">
                            <!-- <div class="form-group">
                                <input _ngcontent-c0="" class="form-control form-control-lg" placeholder="Current Password"
                                    type="password" id="currentPassword" formControlName="currentPassword" />
                                <span *ngIf="f.currentPassword.touched && f.currentPassword.errors?.required"
                                    class="help-block alert-danger">Current Password is Required!</span>
                            </div> -->
                            <div class="form-group">
                                <input _ngcontent-c0="" class="form-control form-control-lg" placeholder="New Password"
                                    type="password" id="password" formControlName="newPassword" />
                                <span *ngIf="f.newPassword.touched && f.newPassword.errors?.required"
                                    class="help-block alert-danger">{{'resetPassword.text4' | translate}}</span>
                                <span *ngIf="f.newPassword.touched && f.newPassword.errors?.minlength"
                                class="help-block alert-danger">{{'resetPassword.text5' | translate}}</span>
                            </div>
                            <div class="form-group">
                                <input _ngcontent-c0="" class="form-control form-control-lg"
                                    placeholder="Confirm Password" type="password" id="cpassword"
                                    formControlName="confirmPassword" />
                                <span *ngIf="f.confirmPassword.touched && f.confirmPassword.errors?.required"
                                    class="help-block alert-danger">{{'resetPassword.text6' | translate}}</span>
                                    <span
                                    *ngIf="f.confirmPassword.errors?.notMatching"
                                    class="help-block alert-danger">{{'resetPassword.text7' | translate}}</span>
                                    <span *ngIf="f.confirmPassword.touched && f.confirmPassword.errors?.minlength"
                                    class="help-block alert-danger">{{'resetPassword.text8' | translate}}</span>
                            </div>
                            <div class="form-group">
                                <div>
                                        <button type="submit" class="btn btn-primary" [disabled]="passwordResetForm.invalid" >{{'resetPassword.text9' | translate}}</button>
                                        <button type="submit" class="btn btn-primary" (click)="goBackToHome()">{{'resetPassword.text10' | translate}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
